import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { themeButtons } from "../../../css/themeButtons";
import { AccordionDetailStyled, AccordionStyled } from "../../CalendarSubscription/styles";
import { RenderPriceTableSubscriber } from "../../CalendarSubscription/CalendarSubscription";
import AutoSaveWithDebounce from "../../common/Autosave/AutoSaveWithDebounce";
import Modal from "../../common/Modals/Modal";
import { usePrevious } from "../../common/CustomHook/usePrevious";


const getPricesArr = (table) => {
  return Object.values({ ...table }).reduce((acc, cur) => {
    if (cur.prices) {
      acc = [...acc, ...Object.values(cur.prices)].filter(item => !!item)
    }
    return acc
  }, [])
}


const FastPrices = ({
  getPrices,
  objectId,
  calendar = {},
  updaterPriceType,
  getPriceTypes,
  priceTypes,
  goPage,
  savePrices,
  clearCalendar,
  setStatusStepByStep,
  getObjectsList,
  getObjectById,
  updateSavingStatus,
}) => {

  const [pricesRooms, setPricesRooms] = useState({})
  const [unsavedPage, toggleUnsavedPage] = useState(false)

  const [pricesErr, setPricesErr] = useState(null)
  const history = useHistory()

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  //состояние и контроль аккордиона
  const [expanded, setExpanded] = useState();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [showInstruction, setShowInstruction] = useState(false);
  const toggleShowInstruction = () => {
    setShowInstruction(!showInstruction)
  }


  useEffect(() => {

    return () => {
      clearCalendar()
    }

  }, [])

  //запрос на получение цен и типов цены
  useEffect(() => {
    if (objectId && Object.keys(calendar).length === 0) {
      getPrices(objectId)
    }
    if (!priceTypes) {
      getPriceTypes()
    }
  }, [objectId])


  //установка активной панели аккордиона
  const prevExpanded = usePrevious(expanded)
  useEffect(() => {
    if (calendar && prevExpanded != Object.keys(calendar)[0]) {
      setExpanded(Object.keys(calendar)[0])
    }
  }, [calendar])


  const presavedPrice = (priceRoom) => {
    setPricesRooms({ ...pricesRooms, ...priceRoom })
  }

  const handleEndCreate = useCallback(async () => {
    updateSavingStatus({ status: "loading" })

    setStatusStepByStep("N")
    await getObjectById(objectId)

    await getObjectsList();
    updateSavingStatus(false)
    history.replace(`/lk/contracts/${objectId}`)
  }, [getObjectById, getObjectsList, history, objectId, setStatusStepByStep, updateSavingStatus])

  //сохранение страницы
  const savePage = async () => {
    if (unsavedPage) {
      toggleUnsavedPage(false)

      let response = await savePrices({ object: objectId, rooms: JSON.stringify(pricesRooms) })

      if (response) {
        if (response.length !== 0) {
          await handleEndCreate();
        } else {
          setPricesErr("Календарь цен не может быть пустым")
        }

      }

    } else {
      await handleEndCreate()
    }

  }

  const goBackToInitialState = (roomId) => {
    let pricesRoomsCopy = { ...pricesRooms }
    delete pricesRoomsCopy[roomId]

    if (Object.keys(pricesRoomsCopy).length === 0) {
      toggleUnsavedPage(false)
    }
  }
  const updatePriceType = (room, values) => {
    toggleUnsavedPage(true)
    updaterPriceType(room, values.priceType)
    setExpanded(room)
  }


  const disabledSubmite = useMemo(() => {


    if (getPricesArr(pricesRooms).length === 0 && getPricesArr(calendar).length !== 0) {
      return unsavedPage
    }

    if (getPricesArr(pricesRooms).length === 0 && getPricesArr(calendar).length === 0) {
      return true
    }

    // return unsavedPage

  }, [unsavedPage, pricesRooms, calendar])


  const buttons = themeButtons()
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Цены</Typography>
        <div className="d-flex flex-wrap">
          <Box className="instruction" onClick={toggleShowInstruction}>
            <span className="instruction__text">Инструкция</span>
            <IconButton>
              <FontAwesomeIcon icon={["far", "question-circle"]}/>

            </IconButton>
          </Box>

        </div>
      </div>


      <div className="stepByStepWrp__body">
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        {pricesErr && <Box className="alert alert-danger mb-3">
          <Typography>{pricesErr}</Typography>
        </Box>}

        <div id="rooms-calendar" className="mb-3">

          {Object.keys(calendar).length !== 0
            ? <>
              {Object.keys(calendar).map((room) => {
                return <AccordionStyled key={room}
                                        expanded={expanded === room}
                                        className="room-calendar"
                                        onChange={handleChange(room)}>

                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div className="room-calendar__header ">
                      <h5 className="m-2 ms-0">{calendar[room].name}</h5>

                      {expanded === room &&
                        <Formik enableReinitialize
                                initialValues={{ priceType: calendar[room].priceType ? calendar[room].priceType : "334" }}
                                onSubmit={(values) => updatePriceType(room, values)}>
                          {({ values }) =>
                            <Form>
                              <Field name="priceType">
                                {({ field }) => {
                                  return <FormControl variant="outlined"
                                                      size="small"
                                                      onClick={(event) => event.stopPropagation()}
                                                      onFocus={(event) => event.stopPropagation()}>

                                    <InputLabel>Тип цены</InputLabel>


                                    <Select {...field}
                                            label="Тип цены">
                                      {priceTypes && Object.keys(priceTypes).map(id =>
                                        <MenuItem key={id} value={`${id}`}>
                                          {priceTypes[id]}
                                        </MenuItem>
                                      )}


                                    </Select>
                                  </FormControl>
                                }}
                              </Field>
                              <AutoSaveWithDebounce debounceMs={10}/>
                            </Form>
                          }

                        </Formik>
                      }


                    </div>

                    <div className="room-calendar__header-btn-text">Посмотреть/Редактировать
                    </div>
                  </AccordionSummary>


                  <AccordionDetailStyled>

                    <RenderPriceTableSubscriber {...calendar[room]}
                                                presavedPrice={presavedPrice}
                                                goBackToInitialState={goBackToInitialState}
                                                toggleUnsavedPage={toggleUnsavedPage}/>
                  </AccordionDetailStyled>
                </AccordionStyled>
              })}
            </>
            : <Skeleton width={"100%"} height={"120px"}/>
          }


        </div>

        <Modal toggleShow={toggleShowInstruction} show={showInstruction}
               title={"Инструкция:"}
               textBtnOk={"Понятно"}>
          <Typography variant="body1" gutterBottom>
            <b>1. Добавление периода.</b> Нажмите на кнопку "Добавить период". Выберите даты начала и
            окончания
            периода и нажмите кнопку "Добавить";
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>2. Редактирование цены.</b> Введите нужную сумму на пересечении строки периода и колонки типа
            размещения, после нажмите кнопку сохранить в нижней части экрана.
            Так же Вы можете редактировать цены сразу в нескольких ячейках и сохранять их все вместе;
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>3. Изменение типа цены.</b> Нажмите на кнопку "Тип цены", которая находится рядом с названием
            номера, в выпадающем списке выберите тип цены номер.
            <b>Обратите внимание. Таблица будет изменена и цены надо будет ввести заново</b>;
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>4. Добавление типа размещения.</b> Нажмите кнопку добавить в самой правой колонке таблицы,
            выберите тип размещения в выпадающем списке и нажмите, тип размещения будет добавлен в таблицу;
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>5. Удаление типа размещения.</b> Нажмите кнопку с типом размещения, находящуюся в самой
            верхней
            строке таблицы цены номера. В выпадающем списке выберите "Удалить столбец";
          </Typography>

        </Modal>


      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={() => goPage("cm")}>Назад</Button>
        <Button className={`btn ${buttons.btnGreen}`}
                disabled={disabledSubmite} onClick={savePage}>Перейти к заключению договора</Button>
      </div>
    </div>


  )
}


export default FastPrices;
